import { formatSlovakPhone } from './phoneFormatter';

/**
 * Formátuje telefónne číslo (zjednotená logika s phoneFormatter)
 * @param {string} phone - Telefónne číslo
 * @returns {string} Formátované telefónne číslo
 */
export const formatPhoneNumber = (phone) => formatSlovakPhone(phone);
